import { Card, Col, Divider, Form, Row } from 'antd';

import { ReactComponent as TruckIcon } from '@/assets/icons/truck-timeline-success.svg';
import Button from '@/views/components/Buttons/Button';
import SvgConverter from '@/views/components/Common/SvgConverter';
import FormDatePicker from '@/views/components/Inputs/FormDatePicker';
import FormInput from '@/views/components/Inputs/FormInput';
import FormRadioGroup from '@/views/components/Inputs/FormRadioGroup';
import FormSelectBox from '@/views/components/Inputs/FormSelectBox';
import Badge from '@/views/components/Labels/Badge';
import PrimaryLabel from '@/views/components/Labels/PrimaryLabel';
import SecondaryLabel from '@/views/components/Labels/SecondaryLabel';
import Drawer from '@/views/components/Modals/Drawer';

import { INITIAL_TRAILER_DETAILS, SHIPMENT_TYPE } from './constants';
import SaverShipmentTransportForm from './SaverShipmentTransportForm';

const SaversShipmentForm = ({
  statusModal,
  setStatusModal,
  trailerShipmentForm,
  handleSubmit,
  trailerNumberOptions,
  onTrailerNumberInput,
  shipmentNo,
  trafficCoordinatorOptions,
  label,
  saversMenuType,
  partnerLocationOptions,
  trailerMovementData,
  dropdownState,
  carrierOptions,
  carrierOptionsLoading,
}) => {
  return (
    <Drawer
      width="80%"
      open={statusModal}
      headerContents={<PrimaryLabel className="text-white">Shipment: {shipmentNo}</PrimaryLabel>}
      onClose={() => setStatusModal(false)}
    >
      <div className="p-10 w-100" style={{ height: '95%', overflowY: 'auto' }}>
        <div className="color-1 pb-10 text-center">
          <strong className="f-20"> {label}</strong>
        </div>
        <Form
          form={trailerShipmentForm}
          initialValues={INITIAL_TRAILER_DETAILS}
          onFinish={(data) => handleSubmit(data, saversMenuType)}
        >
          <div className="trailer-form">
            <Card size="small" className="mb-10" title="Basic Information">
              <Row gutter={15} className="mb-5">
                <Col sm={4}>
                  <FormSelectBox
                    label="Trailer #"
                    editMode
                    name="trailerNumber"
                    margin="m-0"
                    placeholder="Trailer #"
                    options={trailerNumberOptions}
                    onChange={onTrailerNumberInput}
                    disabled
                  />
                </Col>
                {saversMenuType === 'Edit' ? (
                  <>
                    <Col sm={4}>
                      <FormInput
                        name="txtUserName"
                        label="User Name"
                        margin="m-0"
                        editMode
                        placeholder="Auto populated value"
                      />
                    </Col>
                    <Col sm={4}>
                      <FormInput name="rscm" label="RSCM" margin="m-0" editMode placeholder="Auto populated value" />
                    </Col>
                    <Col sm={4}>
                      <FormInput name="scs" label="SCS" margin="m-0" editMode placeholder="Auto populated value" />
                    </Col>
                    <Col sm={4}>
                      <FormSelectBox
                        label="Traffic Coordinator"
                        editMode
                        name="TrafficCoord"
                        margin="m-0"
                        options={trafficCoordinatorOptions}
                        placeholder="Select Traffic Coordinator"
                      />
                    </Col>
                  </>
                ) : (
                  <Col sm={6}>
                    <FormSelectBox
                      label="Trailer / Unit Size"
                      editMode
                      name="unitSize"
                      margin="m-0"
                      placeholder="Select Unit Size"
                      disabled
                    />
                  </Col>
                )}
              </Row>

              {saversMenuType === 'Edit' && (
                <Row gutter={15} className="mb-5">
                  <Col sm={14}>
                    <Row gutter={15}>
                      <Col sm={6}>
                        <FormSelectBox
                          label="Trailer / Unit Size"
                          editMode
                          name="unitSize"
                          margin="m-0"
                          placeholder="Select Unit Size"
                          disabled
                        />
                      </Col>

                      <Col sm={6}>
                        <FormInput
                          label="Inventory move justification"
                          editMode
                          margin="m-0"
                          placeholder="User Entry"
                          name="txtinvJusti"
                        />
                      </Col>

                      <Col sm={6}>
                        <FormSelectBox
                          label="Commodity - Product"
                          editMode
                          name="commodity"
                          margin="m-0"
                          placeholder="Select Commodity"
                          labelInValue
                          options={dropdownState.commodityOptions}
                          loading={dropdownState.loading.commodities}
                        />
                      </Col>

                      <Col sm={6}>
                        <FormSelectBox
                          label="Rental Company"
                          editMode
                          name="unitRentalCompanyID"
                          margin="m-0"
                          placeholder="Select Rental Company"
                          options={dropdownState.rentalCompanyOptions}
                          loading={dropdownState.loading.rentalCompany}
                        />
                      </Col>
                    </Row>

                    <Row gutter={15}>
                      <Col sm={6}>
                        <FormDatePicker label="Entry Date" name="entryDate" margin="m-0" />
                      </Col>

                      <Col sm={6}>
                        <FormDatePicker label="Empty Date" name="emptyDate" margin="m-0" placeholder="Empty Date" />
                      </Col>
                      <Col sm={6}>
                        <FormSelectBox
                          label="Carrier"
                          editMode
                          name="carrier"
                          margin="m-0"
                          options={carrierOptions}
                          loading={carrierOptionsLoading}
                          placeholder="Select Carrier"
                        />
                      </Col>
                      <Col sm={6}>
                        <FormInput
                          label="Shipping Cost"
                          editMode
                          margin="m-0"
                          placeholder="Shipping Cost"
                          name="shippingCost"
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col sm={9} offset={1}>
                    <Row gutter={15} className="mt-5">
                      <Col sm={10}>
                        <SecondaryLabel> Roll Door?: </SecondaryLabel>
                        <Row gutter={15}>
                          <Col sm={24}>
                            <FormRadioGroup
                              options={[
                                {
                                  label: 'Yes',
                                  value: true,
                                },
                                {
                                  label: 'No',
                                  value: false,
                                },
                              ]}
                              name="rollDoor"
                              disabled
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col sm={14}>
                        <Row gutter={15}>
                          <Col>
                            <SecondaryLabel> Direct from partner?: </SecondaryLabel>
                            <FormRadioGroup
                              options={[
                                {
                                  label: 'Yes',
                                  value: true,
                                },
                                {
                                  label: 'No',
                                  value: false,
                                },
                              ]}
                              disabled
                              name="directFromPartner"
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </Card>
            <Card size="small" className="mb-4 overflow-auto" title="Transportation Information">
              <div className="h-100 d-flex flex-direction-column">
                <Row
                  gutter={4}
                  className="my-10 px-30 transportation-edit-badges-container"
                  align="middle"
                  justify="space-between"
                >
                  <Col>
                    <Badge bgColor="border" color="label">
                      {String(1).padStart(2, '0')}
                    </Badge>
                  </Col>
                  <Col flex={1}>
                    <div className="horizontal-line" />
                  </Col>
                  <Col>
                    <SvgConverter Icon={TruckIcon} color="border" className="d-flex" />
                    <SecondaryLabel className="text-border f-14 fw-600 lh-0">Pickup</SecondaryLabel>
                  </Col>
                  <Col flex={1}>
                    <div className="horizontal-line" />
                  </Col>
                  <Col flex={1}>
                    <div className="horizontal-line" />
                  </Col>

                  <Col>
                    <SvgConverter Icon={TruckIcon} color="border" className="d-flex" />
                    <SecondaryLabel className="text-border f-14 fw-600 lh-0">Delivery</SecondaryLabel>
                  </Col>
                  <Col flex={1}>
                    <div className="horizontal-line" />
                  </Col>
                  <Col className="transportation-edit-badges-container">
                    <Badge bgColor="border" color="label">
                      {String(1).padStart(2, '0')}
                    </Badge>
                  </Col>
                </Row>
                <Divider className="mt-0 mb-10 ml-n16 vw-100" />
                <div className="pt-10 px-30 custom-scroll-bar overflow-x-hidden" style={{ height: '210px' }}>
                  <Row gutter={15} align="stretch">
                    <Col sm={12}>
                      <div className="shipping-column">
                        <Form.List name="trailerShippings">
                          {(fields) =>
                            fields.map(({ key, name }) => (
                              <div key={key} className="mb-8">
                                <SaverShipmentTransportForm
                                  form={trailerShipmentForm}
                                  shipmentType={SHIPMENT_TYPE.org}
                                  saversMenuType={saversMenuType}
                                  partnerLocationOptions={partnerLocationOptions}
                                  index={name}
                                  label={label}
                                />
                              </div>
                            ))
                          }
                        </Form.List>
                      </div>
                    </Col>
                    <Col sm={12}>
                      <div className="destination-column">
                        <Form.List name="trailerReceivings">
                          {(fields) =>
                            fields.map(({ key, name }) => (
                              <div key={key} className="mb-8">
                                <SaverShipmentTransportForm
                                  form={trailerShipmentForm}
                                  shipmentType={SHIPMENT_TYPE.dest}
                                  saversMenuType={saversMenuType}
                                  partnerLocationOptions={partnerLocationOptions}
                                  index={name}
                                  label={label}
                                  trailerMovementData={trailerMovementData}
                                />
                              </div>
                            ))
                          }
                        </Form.List>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Card>
            <div>
              {!trailerMovementData?.trailerReceivedFlag && saversMenuType === 'Received at location' && (
                <Button type="primary" htmlType="submit">
                  {saversMenuType}
                </Button>
              )}
              {saversMenuType === 'Generate Outbound Transfer' && !trailerMovementData.isOutboundTransfer && (
                <Button type="primary" htmlType="submit">
                  {saversMenuType}
                </Button>
              )}
              {saversMenuType === 'Generate Inbound Transfer' && !trailerMovementData.isInboundTransfer && (
                <Button type="primary" htmlType="submit">
                  {saversMenuType}
                </Button>
              )}
              {saversMenuType === 'Generate Payment' && !trailerMovementData.isGeneratePayment && (
                <Button type="primary" htmlType="submit">
                  {saversMenuType}
                </Button>
              )}

              {saversMenuType === 'Generate Inbound/Outbound Transfer' && (
                <Row gutter={15}>
                  <Col sm={12}>
                    <Button
                      type="primary"
                      disabled={trailerMovementData.isOutboundTransfer}
                      onClick={() => {
                        trailerShipmentForm.validateFields().then((values) => {
                          handleSubmit(values, 'Generate Outbound Transfer');
                        });
                      }}
                    >
                      Generate Outbound Transfer
                    </Button>
                  </Col>
                  <Col sm={12}>
                    <Button
                      type="primary"
                      disabled={trailerMovementData.isInboundTransfer}
                      onClick={() => {
                        trailerShipmentForm.validateFields().then((values) => {
                          handleSubmit(values, 'Generate Inbound Transfer');
                        });
                      }}
                    >
                      Generate Inbound Transfer
                    </Button>
                  </Col>
                </Row>
              )}
              {label.includes('Loaded') && saversMenuType === 'Edit' && (
                <Button type="primary" htmlType="submit">
                  Save
                </Button>
              )}
            </div>
          </div>
        </Form>
      </div>
    </Drawer>
  );
};

export default SaversShipmentForm;
